import { Children } from 'react';
import PropTypes from 'prop-types';

import Menus from 'providers/menuMaker/Menus';
import MenuDetails from 'providers/menuMaker/MenuDetails';
import MenuProducts from 'providers/menuMaker/MenuProducts';
import MenuPreview from 'providers/menuMaker/MenuPreview';
import Categories from 'providers/menuMaker/Categories';
import CategoryDetails from 'providers/menuMaker/CategoryDetails';
import Products from 'providers/menuMaker/Products';
import ProductDetails from 'providers/menuMaker/ProductDetails';
import ModifierGroups from 'providers/menuMaker/ModifierGroups';
import ModifierGroupDetails from 'providers/menuMaker/ModifierGroupDetails';
import DrawerState from 'providers/menuMaker/DrawerState';

import ComposeProviders from 'components/ComposeProviders';

/**
 * Root provider component for MenuMaker
 * @param {Object} props - Component props
 * @param {React.ReactElement} props.children - Child component
 * @returns {React.ReactElement} MenuMakerRootProvider component
 */
function MenuMakerRootProvider({ children }) {
  return (
    <ComposeProviders
      providers={[
        <Menus />,
        <MenuDetails />,
        <MenuProducts />,
        <MenuPreview />,
        <Categories />,
        <CategoryDetails />,
        <Products />,
        <ProductDetails />,
        <ModifierGroups />,
        <ModifierGroupDetails />,
        <DrawerState />,
      ]}
    >
      {Children.only(children)}
    </ComposeProviders>
  );
}

MenuMakerRootProvider.propTypes = {
  children: PropTypes.element,
};

export default MenuMakerRootProvider;
